module.exports = __webpack_public_path__ + "img/bg.9edcf11a.jpg";